var map = {
	"./Arsenal.png": 118,
	"./Atletico Madrid.png": 962,
	"./Barcelona.png": 142,
	"./Bayern.png": 603,
	"./Copenhagen.png": 46,
	"./Dortmund.png": 317,
	"./Inter Milan.png": 838,
	"./Lazio.png": 34,
	"./Man City.png": 403,
	"./Napoli.png": 333,
	"./PSG.png": 862,
	"./PSV.png": 45,
	"./Porto.png": 174,
	"./RB Leipzig.png": 770,
	"./Real Madrid.png": 363,
	"./Real Sociedad.png": 649
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 331;